import { getQueryString } from '@/utils/environment';
import { NativeService } from 'service/native/nativePluginService';
import config from 'config';

let history = [],
  routerProxy = {},
  changeByRouter = false,
  isBacking = false,
  isGoingForward = false,
  needDelayReset = false,
  currentHash = '',
  subTreeUtils = '';

/**
 * 为什么会有changeByRouter这个变量
 * 因为我们需要区分是通过hlyRouter造成的路由变换还是通过浏览器返回键触发的
 */

function getCallback(location, onComplete, onAbort, isPush) {
  let currentOnComplete,
    currentOnAbort,
    { fullPath } = routerProxy.match(location);

  currentOnComplete = (...params) => {
    isPush ? history.push(fullPath) : history.splice(history.length - 1, 1, fullPath);
    onComplete && onComplete(...params);
  };

  currentOnAbort = (...params) => {
    changeByRouter = false;
    onAbort && onAbort(...params);
  };

  return {
    currentOnComplete,
    currentOnAbort,
  };
}

function getHash(URL) {
  const href = URL;
  const index = href.indexOf('#');
  return index === -1 ? '' : href.slice(index + 1);
}

function addQueryParams(location) {
  let loginType = getQueryString('loginType') || '';
  if (!['wx', 'lark', 'feishu'].includes(loginType)) return;
  let corpId = getQueryString('corpId');
  if (!subTreeUtils) {
    subTreeUtils = require('@/sub-tree/common/src/base/utils');
  }
  let tokenQuery;
  if (['wx'].includes(loginType)) {
    tokenQuery = subTreeUtils.getLocationAccessParams({ corpId });
  } else if (['lark', 'feishu'].includes(loginType)) {
    tokenQuery = subTreeUtils.getLocationAccessParams({
      corpId,
      platform: loginType,
      appId: getQueryString('appId') || '',
    });
  }
  if (!tokenQuery) return;
  if (location.query) {
    location.query['accessParams'] = tokenQuery.accessParams;
  } else {
    location['query'] = {
      accessParams: tokenQuery.accessParams,
    };
  }
}

export const hlyRouter = Object.freeze({
  push(location, onComplete, onAbort) {
    addQueryParams(location);
    changeByRouter = true;
    let { currentOnComplete, currentOnAbort } = getCallback(location, onComplete, onAbort, true);
    routerProxy.push(location, currentOnComplete, currentOnAbort);
  },
  replace(location, onComplete, onAbort) {
    addQueryParams(location);
    changeByRouter = true;
    let { currentOnComplete, currentOnAbort } = getCallback(location, onComplete, onAbort, false);
    routerProxy.replace(location, currentOnComplete, currentOnAbort);
  },
  go(n) {
    window.hlyCommon && window.hlyCommon.go ? window.hlyCommon.go(n) : routerProxy.go(n);
  },
  back() {
    this.go(-1);
  },
  //虚拟路由返回
  virtualGoBack() {
    if (history.length > 1) {
      routerProxy.go(-1);
    }
  },
  hasVirtualGoBack() {
    return history.length > 1;
  },
  forward() {
    this.go(1);
  },
});

/**
 * 路由install之前执行
 */
export function setupListener(Vue) {
  Vue.prototype.hlyRouter = hlyRouter;
  // Object.defineProperty(window, 'hlyRouter', {
  //   get(){
  //     return hlyRouter
  //   }
  // });
  Object.defineProperty(window, '_routerHistory', {
    get() {
      return history;
    },
  });

  Object.defineProperty(window, '_isBacking', {
    get() {
      return isBacking;
    },
    set(val) {
      isBacking = val;
    },
  });
  Object.defineProperty(window, '_isGoingForward', {
    get() {
      return isGoingForward;
    },
  });

  window.addEventListener('message', (rs) => {
    let map = {
      dev: 'http://dev.huilianyi.com',
      uat: 'http://uat.huilianyi.com',
      stage: 'https://stage.huilianyi.com',
      prod: 'https://console.huilianyi.com',
    };
    if (rs.origin !== map[config.env]) {
      return -1;
    } else {
      switch (rs.data) {
        case 'goBack':
          hlyRouter.back();
          break;
        case 'goForward':
          hlyRouter.forward();
          break;
        case 'refresh':
          window.location.reload();
          break;
        default:
          break;
      }
    }
  });

  window.addEventListener('hashchange', ($e) => {
    let isWeChatEnv = ['wxmp'].indexOf(getQueryString('loginType')) !== -1;
    let isLarkEnv = ['feishu'].indexOf(getQueryString('loginType')) !== -1;
    let superTraceId = sessionStorage.getItem('hly.superTraceId');
    if (isWeChatEnv) {
      NativeService().setShareLink();
    }
    if (isLarkEnv) {
      const cacheCorpId = sessionStorage.getItem('corpId');
      NativeService().config(location.href.split('#')[0], cacheCorpId);
    }
    if (needDelayReset) {
      needDelayReset = false;
      setTimeout(() => {
        changeByRouter = false;
      });
    }
    // changeByRouter为false则点击浏览器按键
    if (!changeByRouter) {
      // next(false) 之后会再次改变hash，所以需要重制
      isBacking = false;
      isGoingForward = false;

      let { newURL } = $e,
        newHash = getHash(newURL);
      // 返回
      if (newHash === history[history.length - 2]) {
        isBacking = true;
      } else if (currentHash !== newHash) {
        // next(false)时相等
        isGoingForward = true;
      }
    }
    if (superTraceId) {
      const { history: { current: { matched } = {} } = {} } = getCurrentRouters();
      const routesPath = Array.isArray(matched) && matched.length > 0 ? matched[0].path : undefined;
      window._helios_track_event.recordRouteChange(routesPath).then();
    }
  });
}

/**
 * 路由install之后执行
 * @param vm
 * @returns {*}
 * @constructor
 */
export function InitRouterTool(vm) {
  routerProxy = vm.$router;
  //
  if (routerProxy) {
    routerProxy.afterHooks &&
      routerProxy.afterHooks.push(() => {
        currentHash = routerProxy.currentRoute.fullPath;

        // replace或者push时，先触发afterHooks再触发hashchange，所以延迟将changeByRouter置为false
        changeByRouter && (needDelayReset = true);
        if (isBacking) {
          isBacking = false;
          history.pop();
        }
        if (isGoingForward) {
          isGoingForward = false;
          history.push(currentHash);
        }
      });
  }

  let locationHash = getHash(window.location.href),
    currentRouteHash = routerProxy.currentRoute ? routerProxy.currentRoute.fullPath : '';
  currentHash = currentRouteHash;

  // 刷新页面时 currentRouteHash === '/'
  // 但实际locationHash !== '/'
  if (currentRouteHash === '/' && locationHash !== '/') {
    currentHash = locationHash;
  }

  history.push(currentHash);
}

export const getCurrentRouters = () => {
  return routerProxy;
};
